import type { PortalData } from '../generated/api';
import config from '../config';
import LocalStorage from './LocalStorage';

export const PORTAL_DATA_KEY = 'portal-data';

async function warm(tenantId?: string) {
  const query = tenantId ? `?tenant_id=${encodeURIComponent(tenantId)}` : '';
  const url = `${config.PROTOCOL}://${config.API_URL}/api/portal-data${query}`;
  let data: PortalData | undefined = undefined;

  try {
    const res = await fetch(url);
    if (res.status !== 200 && res.status !== 304) {
      throw new Error();
    }
    data = await res.json();
  } catch (err) {
    return;
  }

  LocalStorage.set(LocalStorage.Keys.PortalData, data);
  return data;
}

(window as any).careand_warmup = warm();

export const getPortalData = () => LocalStorage.get(LocalStorage.Keys.PortalData);

/**
 * Host-based warmup can miss (e.g. localhost, where the referer hostname
 * matches no tenant). Once a tenantId is known (decoded JWT after login),
 * re-fetch by ?tenant_id= — also covers stored data from a different tenant.
 */
export async function ensurePortalData(tenantId: string) {
  const warmup = (window as any).careand_warmup;
  if (warmup instanceof Promise) await warmup;

  const current = getPortalData();
  if (current?.tenant_id === tenantId) return current;
  return warm(tenantId);
}

/** Tenant jurisdiction province — the default for province fields (health
 * cards, referrals). Falls back to the legacy default when unset. */
export const getTenantProvince = () => getPortalData()?.province || 'Ontario';
